import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AddIcon from '@material-ui/icons/Add'
const Accordion = withStyles({
  root: {
    '&:not(:last-child)': {
      background: '#FFFFFF',
      border: '1px solid #E9E9E9',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      border: ' 1px solid #3d3d3d',
      background:
        'linear-gradient( 152.97deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
      backdropFilter: 'blur(42px)',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    borderBottom: '0',
    marginBottom: -1,
    backgroundColor: '#AD8208',
    fontWeight: 400,
    fontSize: '18px',
    fontFamily: "'Press Start 2P', cursive",
    lineHeight: '23px',
    color: '#fff',
    minHeight: 70,
    '&$expanded': {
      minHeight: 70,
      borderBottom: '0',
      color: '#000',
      //backgroundColor: '#E6FFBC',
    },
    '@media(max-width:605px)': {
      fontSize: '10px',
      minHeight: 50,
      '&$expanded': {
        minHeight: 50,
        borderBottom: '0',
        color: '#000',
        //backgroundColor: '#E6FFBC',
      },
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    // background: "rgb(251, 253, 255)",
    background: '042E2D',
    backdropFilter: 'blur(95px)',
  },
}))(MuiAccordionDetails)
export default function FaqData({ data, index }) {
  const [expanded, setExpanded] = React.useState('panel1')

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <div>
      <Accordion
        square
        defaultExpanded={index == 0 ? true : false}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          expandIcon={
            <AddIcon
              style={{ fontSize: '23px', fontWeight: '400', color: '#fff' }}
            />
          }
        >
          {data.head}
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ color: '#fff', fontSize: '15px' }}>
            {data.summary}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
